import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { Dropdown } from 'src/shared/components/dropdown';
import * as styles from './addPageMenu.module.css';
import { AddPageMenuItems } from './addPageMenuItems';
export function AddPageMenu({ moduleId, controls, position = 'end' }) {
    return (_jsx(Dropdown, { controls: controls, className: clsx('w-fit', styles.menu), position: position, children: _jsx(AddPageMenuItems, { moduleId: moduleId }) }));
}
